import React, { useState, useEffect, useRef } from 'react'
import { Mention, MentionsInput } from 'react-mentions'
import MentionedDefaultStyle from './MentionedDefaultStyle'

export default function MentionsTextarea({
  value,
  onChange,
  data,
  trigger,
  formatData,
  formatMention,
  onKeyPress,
  minHeight,
  placeholder,
  onFocus,
  onBlur,
  readOnly,
  isClient = false,
  isAdmin = false,
  isSupportChat = false,
}) {
  const defaultFormat = (id, display) => {
    return `@${display}`
  }
  const [textMinHeight, setTextMinHeight] = useState(minHeight ? minHeight : 40)
  const containerRef = useRef(null)
  const pathname = window.location.pathname
  const isMyBookingsDetails = pathname.includes('my-bookings/details')
  const isSalesBookings = pathname.includes('sales-bookings')
  const increaseWidth = isMyBookingsDetails || isSalesBookings

  useEffect(() => {
    if (!increaseWidth || !containerRef.current) return
    const textarea = containerRef.current.querySelector('textarea')
    if (!textarea) return

    const paddingValue = isSalesBookings ? '90px' : '46px'
    textarea.style.setProperty('padding-left', paddingValue, 'important')
  }, [increaseWidth, isSalesBookings, value])

  const onChageFunction = (e, newValue, newPlainTextValue, mentions) => {
    const textArea = e.target

    if (textArea && textArea.style) {
      textArea.style.height = 'auto' // Reset height to auto to get the actual scrollHeight
      const offsetHeight = textArea.scrollHeight
      setTextMinHeight(Math.max(offsetHeight, minHeight || 40))
    }

    if (onChange) {
      onChange(e, newValue, newPlainTextValue, mentions)
    }
  }
  return (
    <div ref={containerRef}>
      <MentionsInput
        value={value}
        onKeyPress={onKeyPress}
        onFocus={onFocus}
        onBlur={onBlur}
        placeholder={!!placeholder ? placeholder : 'Reply...'}
        onChange={(e, newValue, newPlainTextValue, mentions) =>
          onChageFunction(e, newValue, newPlainTextValue, mentions)
        }
        className={increaseWidth ? 'chat-padding__control' : ''}
        style={MentionedDefaultStyle(textMinHeight, isClient, isSupportChat)}
        readOnly={readOnly}
      >
        <Mention
          trigger={trigger || '@'}
          displayTransform={formatMention || defaultFormat}
          data={formatData || data || []}
        />
      </MentionsInput>
    </div>
  )
}
